import React from "react";
import styled from "styled-components";
import colors from "../../design/colors";
import fonts from "../../design/typography";
import { useNavigate } from "react-router-dom";
import { rootStore } from "../../mobx/store";
import { getFirstAccessibleRoute } from "@/utils/routePermission";

const AccessDenied = () => {
  const navigate = useNavigate();
  const userRole = rootStore.getProfile?.role ?? null;
  const userPermissions = rootStore.getPermissions || [];

  const handleGoBack = () => {
    // ADMIN이지만 권한이 없는 경우 로그인 페이지로 이동
    if (
      userRole === "ADMIN" &&
      (!userPermissions || userPermissions.length === 0)
    ) {
      // localStorage 정리 (로그아웃과 동일한 처리)
      localStorage.removeItem("admin");
      localStorage.removeItem("user_info");
      localStorage.removeItem("permissions");
      localStorage.removeItem("refresh_token");

      // MobX store 정리
      rootStore.signOut();

      navigate("/login");
    } else {
      const defaultRoute = getFirstAccessibleRoute(
        userRole,
        userPermissions,
        rootStore.getProfile?.userType
      );
      navigate(defaultRoute);
    }
  };

  // ADMIN이지만 권한이 없는 경우의 메시지
  const isAdminWithoutPermissions =
    userRole === "ADMIN" && (!userPermissions || userPermissions.length === 0);

  return (
    <Container>
      <Content>
        <Icon>🚫</Icon>
        <Title>접근 권한이 없습니다</Title>
        <Description>
          {isAdminWithoutPermissions ? (
            <>
              현재 계정에 할당된 권한이 없습니다.
              <br />
              관리자에게 권한 할당을 요청하거나 다시 로그인해주세요.
            </>
          ) : (
            <>
              현재 계정으로는 이 페이지에 접근할 수 없습니다.
              <br />
              필요한 권한이 있다면 관리자에게 문의해주세요.
            </>
          )}
        </Description>
        <Button onClick={handleGoBack}>
          {isAdminWithoutPermissions
            ? "로그인 페이지로 이동"
            : userRole
            ? "메인 페이지로 이동"
            : "로그인 페이지로 이동"}
        </Button>
      </Content>
    </Container>
  );
};

export default AccessDenied;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 100px);
  background-color: ${colors.gray50};
  padding: 20px;
`;

const Content = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 40px;
  background-color: ${colors.white};
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const Icon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.gray900};
  margin-bottom: 16px;
`;

const Description = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.gray600};
  line-height: 1.6;
  margin-bottom: 32px;
`;

const Button = styled.button`
  font-size: 16px;
  font-weight: 600;
  background-color: ${colors.warning};
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.warningDark};
  }

  &:active {
    transform: translateY(1px);
  }
`;
